
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import panierService from "../../services/panier.service"
import {namespace} from "vuex-class";
import enrichissementService from "../../services/enrichissement.service"
import comptageService from "../../services/comptage.service"
import frontService from "../../services/front.service"
import User from "@/views/User.vue";

const userModule = namespace("userModule");
const panierModule = namespace("panierModule")

@Component({
  components: {},
})
export default class Baskets extends Vue {

  @userModule.State
  public user!: any;
  @userModule.Action
  public getUser;

  @userModule.Mutation
  public setPath;

  @userModule.Mutation
  public setItemName;

  @userModule.Mutation
  public setEditFromBasket;

  @Prop() panier;

  @Prop() isDeleting;

  @Prop() readonly resetTrigger: boolean;

  @panierModule.Action
  public removeProduct!: () => void;

  @Prop() readonly history: boolean;

  @panierModule.Mutation
  public setItemCat!: (itemCat: string) => void;

  name = "";
  dialogPreview = false;
  previews = [];
  previewHeaders = [];
  search = '';
  headers = [];
  items = [];
  isLoadingData = false;
  currentOrder = [];
  deleteModal = false;
  itemToDelete = "";
  isLoadingPreview = false;
  idItemInPreview = '';
  finalIsDeleting = false;
  selectedItem = '';

    @Watch("resetTrigger")
    resetSelected() {
        this.items = [];
    }

  previewCss(value) {
    const words = value.split(' ');
    const longest = words.reduce((a, b) => a.length > b.length ? a : b);
    if (longest.length > 15 || value.length > 25) {
      return 'big-preview-header';
    } else if (longest.length > 10 || value.length > 15) {
      return 'medium-preview-header';
    } else {
      return 'preview-header';
    }
  }

  previewCssLeft(value) {
    const words = value.split(' ');
    const longest = words.reduce((a, b) => a.length > b.length ? a : b);
    if (longest.length > 15 || value.length > 25) {
      return 'big-preview-header-left';
    } else if (longest.length > 10 || value.length > 15) {
      return 'medium-preview-header-left';
    } else {
      return 'preview-header-left';
    }
  }

  numberComas(number){
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  getCounting(): number {
    let count = 0;
    if(this.history) {
      this.items.forEach(item => {
        if (item.type === 'Comptage' && (item.state != 1 || this.currentOrder.indexOf(item.id) > -1)) {
          count++;
        }
      });
    } else {
      this.items.forEach(item => {
        if (item.type === 'Comptage') {
          count++;
        }
      });
    }
    return count;
  }

  getEnrichment(): number {
    let count = 0;
    if(this.history) {
      this.items.forEach(item => {
        if (item.type === 'Enrichissement' && (item.state != 1 || this.currentOrder.indexOf(item.id) > -1)) {
          count++;
        }
      });
    } else {
      this.items.forEach(item => {
        if (item.type === 'Enrichissement') {
          count++;
        }
      });
    }
    return count;
  }

  getQuality(): number {
    let count = 0;
    if(this.history) {
      this.items.forEach(item => {
        if (item.type === 'Mise en qualité' && (item.state != 1 || this.currentOrder.indexOf(item.id) > -1)) {
          count++;
        }
      });
    } else {
      this.items.forEach(item => {
        if (item.type === 'Mise en qualité') {
          count++;
        }
      });
    }
    return count;
  }

  setItems(userId, history): void {
    this.$emit('start-loading', true);
    if (history) {
      this.headers = [
        {
          text: 'ID/Référence',
          value: 'id',
          class: 'data-table-header',
          width: '210px'
        },
        {
          text: 'Type',
          value: 'type',
          class: 'data-table-header',
          width:'120px',
          sortable : false
        },
        {
          text: 'Segment',
          value: 'segment',
          class: 'data-table-header',
          width: '100px',
          sortable : false
        },
        {
          text: 'Date',
          value: 'date',
          align: 'center',
          class: 'data-table-header',
          width: '170px'
        },
        {
          text: 'Résultats estimés',
          value: 'result',
          class: 'data-table-header',
          align: 'right',
          width: '165px'
        },
        {
          text: 'Crédits',
          value: 'credit',
          class: 'data-table-header',
          align: 'right',
          width: '120px'
        },
        {
          text: 'Format de l\'export',
          value: 'export',
          align: 'center',
          width: '90px',
          class: 'data-table-header',
          sortable : false
        },
        {
          text: 'Statut',
          value: 'state',
          align: 'center',
          width: '100px',
          class: 'data-table-header'
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'center',
          width: "100px",
          class: 'data-table-header',
          sortable : false
        }
      ],
        this.finalIsDeleting = this.isDeleting;
    } else {
      this.headers = [
        {
          text: 'ID/Référence',
          value: 'id',
          class: 'data-table-header',
          width: '210px'
        },
        {
          text: 'Type',
          value: 'type',
          class: 'data-table-header',
          width:'120px',
          sortable : false
        },
        {
          text: 'Segment',
          value: 'segment',
          class: 'data-table-header',
          width: '100px',
          sortable : false
        },
        {
          text: 'Date',
          value: 'date',
          align: 'center',
          class: 'data-table-header',
          width: '170px'
        },
        {
          text: 'Résultats estimés',
          value: 'result',
          align: 'right',
          class: 'data-table-header',
          width: '165px'
        },
        {
          text: 'Crédits',
          value: 'credit',
          align: 'right',
          class: 'data-table-header',
          width: '120px'
        },
        {
          text: 'Format de l\'export',
          value: 'export',
          align: 'center',
          width: '90px',
          class: 'data-table-header',
          sortable : false
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'center',
          width: '150px',
          class: 'data-table-header',
          sortable : false
        }
      ],
          this.finalIsDeleting = this.panier.isDeleting;
    }
    this.isLoadingData = true;
    if (localStorage.getItem('order') && localStorage.getItem('orderTime')) {
      const orderTime = Number(localStorage.getItem('orderTime'));
      if (Date.now() - orderTime < 86400000) {
        this.currentOrder = JSON.parse(localStorage.getItem('order'));
      } else {
        localStorage.removeItem('order');
        localStorage.removeItem('orderTime');
      }
    }
    panierService.getBasketsFromUser(userId, history ? 'history' : 'current').then(res => {
      res.data.message.Items.forEach(element => {
        const line = {
          reference: element.reference ? element.reference : element.basketId,
          id: element.basketId,
          type: element.basketType == 1 ? 'Comptage' : (element.basketType == 2 ? 'Enrichissement' : element.basketType == 3 ? 'Mise en qualité' : null),
          segment: element.basketSegment === true ? 'Établissements' : 'Entreprise',
          date: element.lastUpdate,
          result: element.basketResult,
          credit: element.credit,
          export: element.basketFormat,
          state: element.basketStatus,
          filters: element.filters
        };
        const index = this.currentOrder.indexOf(line.id);
        if (index > -1 && line.state !== 1) {
          this.currentOrder.splice(index, 1);
          if (this.currentOrder.length === 0) {
            localStorage.removeItem('order');
            localStorage.removeItem('orderTime');
          } else {
            localStorage.setItem('order', JSON.stringify(this.currentOrder));
          }
        }
        this.items.push(line);
      });
      this.$emit('set-panier', this.items);
      this.isLoadingData = false;
    });
  }

  downloadCSVFile(basketId) {
    if(this.finalIsDeleting === false) {
      panierService.getFile(basketId).then(res => {
        window.open(res.data.message.url, '_blank');
      }, err => {
        console.log(err);
      });
    }
  }

  mounted() {
    this.getUser().then(res => {
      if (res === true) {
        this.setItems(this.user.id, this.history);
      } else {
        this.$router.go(0);
      }
    });

    if (this.$route.query.download != undefined) {
      this.downloadCSVFile(this.$route.query.download);
    }

  }

  // TODO : get 10 first lines from file instead of recalculating preview ?
  preview(item) {
    this.previewHeaders = [];
    this.isLoadingPreview = true;
    this.idItemInPreview = item.id;
    //this.isLoadingPreview = this.currentOrder.indexOf(item.id);
    if(this.finalIsDeleting === false) {
      if (item.type === 'Comptage') {
        comptageService.preview(item.filters).then(res => {
          const ids = [];

          let type = 'siren';
          if (item.segment === 'Établissements') {
            type = 'siret'
          }

          for (let index = 0; index < res.data.message.items.length; index++) {
            const element = res.data.message.items[index];
            ids.push(element[type])
          }

          enrichissementService.previewComptage({
            type: type,
            datas: item.filters.datas,
            ids: ids
          }).then((resPreview: any) => {
            this.previewHeaders = this.createdComptageHeadersFile(resPreview.data.message);
            const tempPreviews = resPreview.data.message;
            tempPreviews.shift();
            this.previews = tempPreviews;
            this.dialogPreview = true;
            this.isLoadingPreview = false;
          });
        });
      } else if (item.type === 'Enrichissement') {
        enrichissementService.preview(item.filters).then(res => {
          this.previewHeaders = this.createdEnrichmentHeadersFile(res.data.message);
          const tempPreviews = res.data.message;
          tempPreviews.shift();
          this.previews = tempPreviews;
          this.dialogPreview = true;
          this.isLoadingPreview = false;
        });
      }
    }
  }

  createdEnrichmentHeadersFile(items) {
    const headers = [];

    if (items && items.length > 0) {
      const length = Object.keys(items[1]).length - 2;
      for (let index = 0; index < length; index++) {
        headers.push({
          text: items[0][index] + "",
          value: index + "",
          align: 'center'
        });
      }
    }
    return headers;
  }

  createdComptageHeadersFile(items) {
    const headers = [];
    if (items && items.length > 0) {
      for (const key in Object.keys(items[0]).filter(k => k !== 'lineId')) {
        headers.push({
          text: items[0][key] + "",
          value: key + "",
          align: 'center'
        });
      }
    }
    return headers;
  }

  customSort(items, index, isDesc) {
    if(this.history) {
      return frontService.customSort('date', items, index, isDesc);
    }
    else {
      return frontService.customSortDateName('date', 'state', items, index, isDesc);
    }
  }

  img(value) {
    return require('@/assets/' + value);
  }

  editItem(item) {
    if (item.type == 'Comptage') {
      // TODO : item is not an IComptage (it is a basket), check if something needs to be done
      // this.setComptage(JSON.parse(JSON.stringify(item)));
      // redirect with the right id (fileId ? societe id ?)
      this.$router.push({path: 'comptage/' + item.id});
      this.setItemCat(item.type);
    } else if (item.type == 'Enrichissement') {
      this.$router.push({path: 'enrichissement/' + item.id});
      this.setItemCat(item.type);
    } else if (item.type == 'Mise en qualité') {
      // this.setQualite(JSON.parse(JSON.stringify(item.content)));
      this.$router.push({path: 'qualite/' + item.id});
      this.setItemCat("Qualite"); //entrée en dur car item.type = Mise en qualité
    }
    this.setPath(item.type);
    this.setItemName(item.reference);
    this.setEditFromBasket(true);
  }

  deleteItem(item) {
    this.name = item.name;
    this.deleteModal = true;
    this.itemToDelete = item;
  }

  finalDelete(itemToDelete){
    this.panier.isDeleting = true;
    this.finalIsDeleting = true;
    panierService.deleteBasket(itemToDelete.id).then(res => {
      if (res) {
        this.items = this.items.filter(productSaved => productSaved.id !== itemToDelete.id);
        this.removeProduct();
        this.$emit('set-panier', this.items);
        this.panier.isDeleting = false;
        this.finalIsDeleting = false;
      }
    });
  }

  standardization(value) {
    if(value == "Entreprise")
      return "Sociétés";
    return value;
  }
}


